import { render, staticRenderFns } from "./TagEmailAutomation.vue?vue&type=template&id=f9ab0634&scoped=true&"
import script from "./TagEmailAutomation.vue?vue&type=script&lang=js&"
export * from "./TagEmailAutomation.vue?vue&type=script&lang=js&"
import style0 from "./TagEmailAutomation.vue?vue&type=style&index=0&id=f9ab0634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ab0634",
  null
  
)

export default component.exports